<template>
  <div
    class="image-error"
    :class="compact ? 'image-error-compact' : ''"
    :title="text">
    <i class="el-icon-picture-outline" :class="compact ? 'font-16' : 'font-24'"></i>
    <span v-if="!compact" class="image-error-text">{{ text }}</span>
  </div>
</template>

<script>
// Khung báo lỗi khi content không có link ảnh hợp lệ, hoặc đã thử hết link + retry mà vẫn hỏng.
// Trước đây các nhánh này render rỗng => bubble ảnh biến mất hẳn, người dùng không biết có tin nhắn ảnh.
// compact: dùng cho thumb nhỏ (khung trả lời) - chỉ icon, không chữ.
export default {
  name: "ImageError",
  props: {
    compact: { type: Boolean, default: false },
    text: { type: String, default: "Không tải được ảnh" }
  }
};
</script>

<style scoped>
.image-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  height: 100%;
  min-width: 120px;
  min-height: 80px;
  padding: 8px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background-color: #f4f5f9;
  color: #909399;
  overflow: hidden;
}
.image-error-compact {
  min-width: 0;
  min-height: 0;
  padding: 0;
  gap: 0;
}
.image-error-text {
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
}
</style>
